import { CourseEnrollButtonProps } from "@/components/CourseContent/EnrollButton/types";
import makeEvent from "@/hooks/eventing/makeEvent";
import { ConversionTracked } from "@/hooks/eventing/types/core.conversions.ConversionTracked.v2";
import { EVENTS } from "@/hooks/eventing/types/events";
import { ProcessedCourse } from "@/common/course/types";
import { CourseRun } from "@/common/courseRun/types";
import { TagularAction, TagularCategory } from "@/types/Tagular";
import {
  getCorrelationID,
  getBrandString,
  getVariantCategoryFromUrl,
} from "@/utils/tagular/helpers";

const triggerConversionEvent =
  ({
    customName = "enroll",
    courseRun,
    isUserEntitled,
    course,
    action = TagularAction.STARTED,
  }: {
    customName: CourseEnrollButtonProps["conversionType"] | undefined;
    courseRun: CourseRun;
    isUserEntitled?: boolean;
    course: ProcessedCourse;
    action?: TagularAction;
  }) =>
  () => {
    const { variant, category } = getVariantCategoryFromUrl(
      courseRun.marketingUrl,
    );

    const conversionEvent: ConversionTracked = {
      correlation: { id: getCorrelationID() },
      metadata: {
        customName,
        action,
        category: TagularCategory.ENROLLMENT,
        timestamp: new Date().toISOString(),
        productList: [
          {
            brand: getBrandString(course),
            category,
            variant,
            name: courseRun.title || "unknown",
            id: course.key,
            externalId: courseRun.key,
          },
        ],
      },
    };
    if (isUserEntitled) {
      conversionEvent.revenue = { actualRevenue: { amount: 0 } };
    }
    const event = makeEvent<ConversionTracked, EVENTS>(conversionEvent);
    event<ConversionTracked>(EVENTS.ConversionTracked)();
  };

export default triggerConversionEvent;
